import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface SubmitButtonProps {
  children: React.ReactNode
  loadingLabel?: React.ReactNode
  isLoading?: boolean
  disabled?: boolean
  fullWidth?: boolean
  showIcon?: boolean
  className?: string
}

const baseClassName =
  'flex cursor-pointer items-center justify-center gap-2 rounded-lg py-2.5 font-medium transition-opacity disabled:cursor-not-allowed disabled:opacity-60'

const enabledClassName = 'bg-primary text-primary-foreground hover:opacity-90'
const disabledClassName = 'cursor-not-allowed bg-gray-300 text-gray-500'

export function SubmitButton({
  children,
  loadingLabel,
  isLoading = false,
  disabled = false,
  fullWidth = false,
  showIcon = true,
  className,
}: SubmitButtonProps) {
  const isDisabled = disabled || isLoading

  return (
    <button
      type="submit"
      disabled={isDisabled}
      className={cn(
        baseClassName,
        fullWidth ? 'mt-2 w-full text-base' : 'px-10 text-sm font-semibold',
        isDisabled ? disabledClassName : enabledClassName,
        className
      )}
    >
      {isLoading && loadingLabel != null ? loadingLabel : children}
      {!isLoading && showIcon && (
        <ArrowRight className="text-primary-foreground h-4 w-4 shrink-0" />
      )}
    </button>
  )
}
